import { Component, OnInit, Input, ChangeDetectionStrategy, OnDestroy } from '@angular/core';
import { ChapterModel } from 'src/app/story/models/chapter.model';
import { Store, Select } from '@ngxs/store';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable, Subject } from 'rxjs';
import { SelectChapter } from 'src/app/story/state/chapters/story.chapters.actions';
import { StoryChapterThumbnail } from 'src/app/story/models/story-chapter-thumbnail.model';
import { takeUntil, filter, takeWhile, take } from 'rxjs/operators';

@Component({
  selector: 'app-view-chapters-list',
  templateUrl: './view-chapters-list.component.html',
  styleUrls: ['./view-chapters-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ViewChaptersListComponent implements OnInit, OnDestroy {
  @Select(StoryChaptersState.getStoryChapters)
  chapters$: Observable<ChapterModel[]>;

  @Select(StoryChaptersState.getSelectedChapter)
  selectedChapter$: Observable<ChapterModel>;

  @Select(StoryChaptersState.getRegisteredThumbnails)
  thumbnails$: Map<string, StoryChapterThumbnail>;

  private ngUnsubscribe = new Subject();

  constructor(
    private store: Store
  ) { }

  ngOnInit() {
    
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();

  }

  handleChapterClick(chapter: ChapterModel) {
    this.store.dispatch(new SelectChapter(chapter));
  }

  
}
